import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useOpenState } from "../contexts/OpenContext";
import _ from "lodash";

const Home = () => {
  const { state } = useOpenState();
  const [list, setList] = useState([]);
  const [filter_list, setFilter_list] = useState([]);
  const [search_value, setSearch_value] = useState("");
  const [select_menu, setSelect_menu] = useState();
  const navigate = useNavigate();

  useEffect(() => {
    if (state.menu.length > 0 && state.selected_menu !== null) {
      setList(state.menu.find((el) => el.id === state.selected_menu).articles);
      setSelect_menu(state.menu.find((el) => el.id === state.selected_menu));
    }
  }, [state.menu, state.selected_menu]);

  useEffect(() => {
    var result = list;
    if (search_value) {
      result = _.filter(result, (a) =>
        _.includes(
          _.toLower(_.toString(a.article_name)),
          _.toLower(_.toString(search_value))
        )
      );
    }
    setFilter_list(result);
  }, [list, search_value]);

  return (
    <div className="max-w-7xl mx-auto px-4">
      <div className="flex flex-wrap items-center justify-center xl:justify-start shadow-md gap-4 mt-4">
        <table className="min-w-full cursor-default">
          <thead className="border-b">
            <tr>
              <th
                scope="col"
                className="text-sm font-medium text-gray-900 px-2 py-2 text-center w-[50px]"
              >
                №
              </th>
              <th
                scope="col"
                className="text-sm font-medium text-gray-900 px-2 py-2 flex items-center justify-between"
              >
                <div className="flex items-start justify-between flex-col md:flex-row md:items-center w-full">
                  <div className="w-ful md:w-[50%] text-left">
                    {select_menu?.category_name +
                      " - " +
                      filter_list.length +
                      " - гарчиг байна."}
                  </div>
                  <input
                    type="search"
                    name="q"
                    className="py-1 text-sm text-gray-900 bg-white rounded px-2 focus:outline-none focus:shadow-outline border w-80"
                    placeholder="Хайх ..."
                    autoComplete="off"
                    onChange={(e) => setSearch_value(e.target.value)}
                    value={search_value}
                  />
                </div>
              </th>
            </tr>
          </thead>
          <tbody className="max-h-[calc(100vh-200px)] scrollbar">
            {filter_list.length > 0 ? (
              filter_list.map((el, index) => {
                return (
                  <tr
                    className="border-b duration-300 cursor-pointer hover:bg-slate-100"
                    key={index}
                    onClick={() => {
                      navigate("/" + el.id);
                    }}
                  >
                    <td className="px-2 py-2 whitespace-nowrap text-sm font-medium text-gray-900 text-center w-[50px]">
                      {index + 1}
                    </td>
                    <td className="text-sm text-gray-900 font-light px-2 py-2">
                      {el.article_name}
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr className="border-b">
                <td
                  className="px-2 py-2 whitespace-nowrap text-sm font-medium text-gray-900 text-center"
                  colSpan={2}
                >
                  Хоосон байна
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default React.memo(Home);
